<template>
  <v-container fluid>
    <v-breadcrumbs :items="breadItems" class="breadcrumb mx-16">
    </v-breadcrumbs>

    <v-card class="mx-16">
      <v-row dense class="d-flex">
        <v-col cols="10">
          <div id="splice-regulation-network">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small outlined color="info" v-bind="attrs" v-on="on" :disabled="isDisableReset"
                  class="show-hide-btn mt-1 v-step-2" @click="
                    hideSelectedRegulators(regulator_select);
                  regulator_select = null;
                  ">
                  <v-icon small>mdi-reply</v-icon>
                </v-btn>
              </template>
              <span>reset</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small outlined color="info" class="download-btn mt-1" v-bind="attrs" v-on="on"
                  @click="downloadNetwork">
                  <v-icon small>mdi-download</v-icon>
                </v-btn>
              </template>
              <span>download</span><br />
            </v-tooltip>
            <div id="network" class="v-step-0">
              <!-- :style="{width: svgSize.width +'px', height: svgSize.height+'px'}" -->
              <div class="linkText" :style="linkTextPosition" v-show="linkTextVisible" v-text="linkTextContent"></div>
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 200 720"
                :width="svgSize.width" :height="svgSize.height"
                :style="{ 'background-color': theme.bgcolor, cursor: 'grab' }" @click="clickEle"
                @mouseover.prevent="svgMouseover" @mouseout="svgMouseout">
                <g id="container">
                  <!-- links and link-text 注：先绘制边 -->
                  <g id="link-group">
                    <g v-for="link in links" :key="link.index">
                      <line :class="`${link[linkTypeKey]} ${link.selected} link element`" :stroke="theme.linkStroke"
                        :stroke-width="linkWidth"></line>
                      <!-- dx dy 文字左下角坐标 -->
                      <text v-if="showLinkText" dx="0" dy="0" class="link-text" :fill="theme.textFill"
                        :font-size="linkTextFontSize">
                        {{ link[linkTextKey] }}
                      </text>
                    </g>
                  </g>

                  <!-- node and node-text -->
                  <g id="node-group">
                    <g v-for="node in nodes" :key="node.index">
                      <circle :fill="nodeColor(node[nodeTypeKey])" :stroke-width="highlightNodes.indexOf(node.id) == -1 ? 3 : 10
                        " :stroke="highlightNodes.indexOf(node.id) == -1
                          ? theme.nodeStroke
                          : 'gold'
                          " :class="`${node[nodeTypeKey]} ${node.showText ? 'selected' : ''
                            } node element`" :r="node.node_size"></circle>
                      <text v-show="node.showText" :dx="getNodeTextX(node.node_size)" :dy="getNodeTextY(node.node_size)"
                        :font-size="getNodeTextSize(node.node_size)" font-family="Arial" font-weight="bold"
                        :fill="theme.textFill" class="node-text">
                        {{ node[nodeTextKey] }}
                      </text>
                    </g>
                    <g></g>
                  </g>
                </g>
              </svg>
            </div>
          </div>
        </v-col>
        <v-col cols="2">
          <v-combobox v-model="regulator_select" prepend-inner-icon="mdi-magnify" clearable
            clear-icon="mdi-close-circle" @click:clear="hideSelectedRegulators(regulator_select)" outlined rounded dense
            hide-no-data class="search_input v-step-1" :loading="regulator_loading" :items="regulator_items"
            :search-input.sync="regulator_search" label="Gene Name" :messages="regulator_message"
            :error-messages="regulator_error_message">
          </v-combobox>
          <div id="network-legend">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%"
              height="500">
              <g>
                <g class="legend-background">
                  <rect x="3%" y="1%" width="94%" height="70%" rx="1" stroke="rgb(0,0,0)" stroke-dasharray="1,5"
                    stroke-width="0.5" fill="white"></rect>
                </g>
                <g class="legend-title">
                  <text x="30%" y="6%" style="
                      font-size: 15px;
                      font-family: Arial;
                      font-weight: bold;
                    ">
                    AS Event Types
                  </text>
                </g>
                <!-- <g class="legend-circle">
                  <circle fill="#1f77b4"
                          stroke-width="3"
                          stroke="white"
                          r="18"
                          cx="20%"
                          cy="10%"
                          style="opacity: 1;">
                  </circle>
                </g>
                <g class="legend-text">
                  <text x="40%"
                        y="10.5%"
                        style="font-size: 13px; font-family: Arial; font-weight: bold;">
                    Splicing Regulator
                  </text>
                </g> -->
              </g>
            </svg>
          </div>
        </v-col>
      </v-row>
    </v-card>

    <v-data-table dense class="data-table-style mt-5 mx-16 v-step-3" :headers="headers" fixed-header
      :items="filteredLinks" v-model="selected" item-key="_id" :search="search" :loading="loading"
      loading-text="Loading... Please wait">
      <!-- item.source.id slot -->
      <template v-slot:[`item.source.id`]="{ item }">
        <a @click="regulator_select = item.source.id">
          <span class="font-weight-bold">{{ item.source.id }}</span>
        </a>
      </template>

      <!-- item.target.id slot -->
      <template v-slot:[`item.target.id`]="{ item }">
        <a @click="regulator_select = item.target.id">
          <span class="font-weight-bold">{{ item.target.id }}</span>
        </a>
      </template>

      <!-- item.visualization slot -->
      <template v-slot:[`item.visualization`]="{ item }">
        <v-btn @click="
          goToVisualiztion(
            item.target.id,
            item.as_type,
            item.event_coordinates
          )
          " color="info" icon :disabled="item.as_type == 'Complex'">
          <v-icon>mdi-tune</v-icon>
        </v-btn>
      </template>

      <!-- item.details slot -->
      <template v-slot:[`item.details`]="{ item }">
        <v-btn @click="goToDetails(item.event_id, item.cancer_name, item.pubmed_id)" color="info" icon>
          <v-icon>mdi-chevron-right-circle</v-icon>
        </v-btn>
      </template>

      <!-- item.pubmed_id slot -->
      <template v-slot:[`item.pubmed_id`]="{ item }">
        <a :href="pubmedLink + item.pubmed_id" target="_blank">{{
          item.pubmed_id
        }}</a>
      </template>

      <!-- item.regulatory_explorer slot -->
      <template v-slot:[`item.regulatory_explorer`]="{ item }">
        <v-btn @click="
          goToRegulationExplorer(
            item.target.id,
            'TCGA',
            item.tcga_project_id,
            item.event_id
          )
          " color="grey" icon :disabled="item.has_oncoprint == 'no' || item.as_type == 'Complex'">
          <svg class="icon" aria-hidden="true" v-if="item.has_oncoprint == 'no' || item.as_type == 'Complex'">
            <use xlink:href="#icon-GridView-diable"></use>
          </svg>
          <svg class="icon" aria-hidden="true" v-else>
            <use xlink:href="#icon-GridView-oncoprint"></use>
          </svg>
        </v-btn>
      </template>

      <!-- item.survival slot -->
      <template v-slot:[`item.survival`]="{ item }">
        <v-btn @click="
          goToSurvival(
            item.target.id,
            'TCGA',
            item.tcga_project_id,
            item.event_id
          )
          " color="info" icon :disabled="item.has_oncoprint == 'no' ||
            item.as_type == 'Complex' ||
            !survival_project_items.includes(item.tcga_project_id)
            ">
          <svg class="icon" aria-hidden="true" v-if="
            item.has_oncoprint == 'no' ||
            item.as_type == 'Complex' ||
            !survival_project_items.includes(item.tcga_project_id)
          ">
            <use xlink:href="#icon-linechart-diable"></use>
          </svg>
          <svg class="icon" aria-hidden="true" v-else>
            <use xlink:href="#icon-linechart"></use>
          </svg>
        </v-btn>
      </template>

      <!-- item.staging slot -->
      <template v-slot:[`item.staging`]="{ item }">
        <v-btn @click="
          goToStaging(
            item.target.id,
            'TCGA',
            item.tcga_project_id,
            item.event_id
          )
          " color="info" icon :disabled="item.has_oncoprint == 'no' ||
            item.as_type == 'Complex' ||
            !stage_project_items.includes(item.tcga_project_id)
            ">
          <svg class="icon" aria-hidden="true" v-if="
            item.has_oncoprint == 'no' ||
            item.as_type == 'Complex' ||
            !stage_project_items.includes(item.tcga_project_id)
          ">
            <use xlink:href="#icon-xiangxiantu-disable"></use>
          </svg>
          <svg class="icon" aria-hidden="true" v-else>
            <use xlink:href="#icon-xiangxiantu"></use>
          </svg>
        </v-btn>
      </template>

      <!-- header.regulatory_explorer slot -->
      <template v-slot:[`header.regulatory_explorer`]="{ header }">
        {{ header.text }}
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small v-bind="attrs" v-on="on">mdi-help-circle</v-icon>
          </template>
          <span>Splicing Regulatory Explorer</span>
        </v-tooltip>
      </template>

      <!-- header.survival slot -->
      <template v-slot:[`header.survival`]="{ header }">
        {{ header.text }}
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small v-bind="attrs" v-on="on">mdi-help-circle</v-icon>
          </template>
          <span>Survival Analysis</span>
        </v-tooltip>
      </template>

      <!-- header.staging slot -->
      <template v-slot:[`header.staging`]="{ header }">
        {{ header.text }}
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small v-bind="attrs" v-on="on">mdi-help-circle</v-icon>
          </template>
          <span>Cancer Staging Analysis</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <!-- back to top -->
    <back-to-top></back-to-top>

    <!-- User guide -->
    <v-tooltip left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="guide-btn-style primary" fab small icon v-bind="attrs" v-on="on"
          @click="$tours['myTour'].start()">
          <v-icon color="white">mdi-book-cog</v-icon>
        </v-btn>
      </template>
      <span>User Guide</span>
    </v-tooltip>

    <v-tour name="myTour" :steps="steps" :options="{ highlight: true }">
    </v-tour>
  </v-container>
</template>

<script>
import * as d3 from "d3";
import { getAllRegulatoryNetwork } from "node/splice_regulatory_network.js";
import BackToTop from "@/components/main/BackToTop";

export default {
  name: "SpliceRegulationNetwork",
  components: {
    BackToTop,
  },
  props: {
    svgSize: {
      type: Object,
      default: () => {
        return {
          width: window.innerWidth,
          height: window.innerHeight,
        };
      },
    },
    // node
    nodeTypeKey: {
      type: String,
      default: "group",
    },
    // node
    nodeSize: {
      type: Number,
      default: 14,
    },
    nodeTextKey: {
      type: String,
      default: "id",
    },
    nodeTextFontSize: {
      type: Number,
      default: 14,
    },
    bodyStrength: {
      type: Number,
      default: -500,
    },

    // link
    linkTypeKey: {
      type: String,
      default: "type",
    },
    linkWidth: {
      type: Number,
      default: 2,
    },
    linkDistance: {
      type: Number,
      default: 60,
    },
    showLinkText: {
      type: Boolean,
      default: false,
    },
    linkTextKey: {
      type: String,
      default: "value",
    },
    linkTextFontSize: {
      type: Number,
      default: 10,
    },

    // others
    // highlightNodes: {
    //   type: Array,
    //   default: () => {
    //     return [];
    //   }
    // },
  },
  data() {
    return {
      nodeList: [],
      linkList: [],
      selection: {
        links: [],
        nodes: [],
      },
      // regulator_node_size: [],
      regulator_list: [],
      highlightNodes: [],
      pinned: [], // 被订住的节点的下标
      force: null,
      zoom: d3.zoom(),
      lastK: 0,
      linkTextVisible: false,
      linkTextPosition: {
        top: 0,
        left: 0,
      },
      linkTextContent: "",
      // nodeColor: d3.scaleOrdinal(d3.schemeCategory10),
      // nodeColor: d3.scaleOrdinal([0, 1, 2, 3, 4, 5, 6],
      //   ['#d62728', '#1f77b4', '#ff7f0e', '#2ca02c', '#9467bd', '#bcbd22', '#17becf']),
      nodeColor: d3.scaleOrdinal(
        [0, 1, 2, 3, 4, 5, 6],
        [
          "#f15854",
          "#5da5da",
          "#decf3f",
          "#b276b2",
          "#faa43a",
          "#60bd68",
          "#8d4b08",
        ]
      ),
      svgTheme: "light",

      breadItems: [
        {
          text: "Home",
          disabled: false,
          href: "/ascancer/home",
        },
        {
          text: "Toolkit",
          disabled: false,
          href: "/ascancer/tools",
        },
        {
          text: "Splicing Regulatory Network",
          disabled: true,
        },
      ],
      steps: [
        {
          target: ".v-step-0",
          content: `1. Interactively view the <span class='font-weight-bold info--text'>splicing regulators</span> 
        and the corresponding <span class='font-weight-bold info--text'>target genes</span>. 
        Nodes size of splicing regulators are proportional to the number of targets. 
        Nodes of different colors represent different AS types.<br/>
        <span class='font-weight-bold red--text'>Tips</span>: 
        Mouseover the node to show the connected sub-network.
        Click the node to focus on the selected splicing regualtor or target gene.
        Click the blank area to remove the selected splicing regulator / target gene. 
        Click the edge to show the splicing event details. 
        Zoom in or out when scrolling the mouse wheel. 
        Press and hold down the left mouse to drag.`,
          params: {
            placement: "bottom",
            enableScrolling: false,
          },
        },
        {
          target: ".v-step-1",
          content: `2. Input the <span class='font-weight-bold info--text'>splicing regulator</span> / <span class='font-weight-bold info--text'>target gene</span> of interest.`,
          params: {
            enableScrolling: false,
          },
        },
        {
          target: ".v-step-2",
          content: `3. Remove the selected splicing regulator / target gene.`,
          params: {
            enableScrolling: false,
          },
        },
        {
          target: ".v-step-3",
          content: `4. Show all or filtered <span class='font-weight-bold info--text'>splicing regualtor-target gene</span> interactions. 
        You can further visualize or explore the splicing events by clicking the buttons provided.`,
          params: {
            enableScrolling: false,
          },
        },
      ],

      regulator_select: null,
      regulator_loading: false,
      regulator_items: [],
      regulator_search: null,
      regulator_list: [],
      regulator_message: null,
      regulator_error_message: null,

      isDisableReset: true,

      search: "",
      loading: true,
      selected: [],
      pubmedLink: "https://pubmed.ncbi.nlm.nih.gov/",
      pageSize: 20,
      pageSizes: [10, 15, 20, 50, 100],
      headers: [
        {
          text: "Splicing Regulator",
          value: "source.id",
          align: "start",
          sortable: true,
        },
        {
          text: "Splicing Target",
          value: "target.id",
          align: "start",
          sortable: false,
        },
        {
          text: "Cancer type",
          value: "cancer_name",
          align: "start",
          sortable: true,
        },
        { text: "AS type", value: "as_type", align: "start", sortable: true },
        {
          text: "Event Coordinates",
          value: "event_coordinates",
          align: "start",
          sortable: false,
        },
        { text: "PubMed", value: "pubmed_id", align: "start", sortable: true },
        { text: "Year", value: "year", align: "start", sortable: true },
        { text: "Journal", value: "journal", align: "start", sortable: true },
        {
          text: "Visualization",
          value: "visualization",
          align: "center",
          sortable: false,
        },
        {
          text: "Explorer",
          value: "regulatory_explorer",
          align: "center",
          sortable: false,
        },
        {
          text: "Survival",
          value: "survival",
          align: "center",
          sortable: false,
        },
        { text: "Staging", value: "staging", align: "center", sortable: false },
        { text: "Details", value: "details", align: "center", sortable: false },
      ],
      survival_project_items: [
        "TCGA-ACC",
        "TCGA-BLCA",
        "TCGA-BRCA",
        "TCGA-CESC",
        "TCGA-CHOL",
        "TCGA-COAD",
        "TCGA-DLBC",
        "TCGA-ESCA",
        "TCGA-GBM",
        "TCGA-HNSC",
        "TCGA-KICH",
        "TCGA-KIRC",
        "TCGA-KIRP",
        "TCGA-LAML",
        "TCGA-LGG",
        "TCGA-LUAD",
        "TCGA-LUSC",
        "TCGA-MESO",
        "TCGA-OV",
        "TCGA-PAAD",
        "TCGA-PCPG",
        "TCGA-PRAD",
        "TCGA-READ",
        "TCGA-SARC",
        "TCGA-SKCM",
        "TCGA-STAD",
        "TCGA-THCA",
        "TCGA-THYM",
        "TCGA-UCEC",
        "TCGA-UCS",
        "TCGA-UVM",
      ],
      stage_project_items: [
        "TCGA-ACC",
        "TCGA-BLCA",
        "TCGA-BRCA",
        "TCGA-CHOL",
        "TCGA-COAD",
        "TCGA-ESCA",
        "TCGA-HNSC",
        "TCGA-KICH",
        "TCGA-KIRC",
        "TCGA-KIRP",
        "TCGA-LUAD",
        "TCGA-LUSC",
        "TCGA-MESO",
        "TCGA-PAAD",
        "TCGA-READ",
        "TCGA-SKCM",
        "TCGA-STAD",
        "TCGA-THCA",
      ],
    };
  },
  created() {
    this.getAllRegulatoryNetwork().then(() => {
      this.initData();
      this.initDragTickZoom();
      if (JSON.stringify(this.$route.query) !== "{}") {
        // 延迟 1s执行，等待节点位置稳定
        setTimeout(() => {
          this.regulator_select = this.$route.query.regulator;
        }, 500);
      }
    });

    // Load external svg2pdf js scripts
    const script1 = document.createElement("script");
    script1.type = "text/javascript";
    script1.src =
      "https://ngdc.cncb.ac.cn/ascancer/api/js/pdfkit.standalone.js";
    document.body.appendChild(script1);

    const script2 = document.createElement("script");
    script2.type = "text/javascript";
    script2.src = "https://ngdc.cncb.ac.cn/ascancer/api/js/svg-to-pdfkit.js";
    document.body.appendChild(script2);
  },
  mounted() {
    this.svgSize.width =
      document.getElementById("splice-regulation-network").clientWidth - 10;
    this.svgSize.height = 750;
    this.plotNetworkLegend();
  },
  watch: {
    bodyStrength: function () {
      this.initData();
      this.$nextTick(function () {
        this.initDragTickZoom();
      });
    },
    linkDistance: function () {
      this.initData();
      this.$nextTick(function () {
        this.initDragTickZoom();
      });
    },
    nodes: function () {
      this.initData();
      this.$nextTick(function () {
        // 以下这个函数重新在 node 上调用了拖拽
        // 只有在 mounted 后才有用
        // 所以要使用 $nextTick
        this.initDragTickZoom();
      });
    },
    links(val) {
      if (val) {
        this.loading = false;
      }
    },
    regulator_select(val) {
      // console.log(val);
      if (val == null || val == "") {
        this.isDisableReset = true;
        this.highlightNodes = [];
        // console.log(this.$route.query);
        // 删除路径上的查询参数
        this.$router
          .push({
            path: "/tools/regnet",
            query: {},
          })
          .catch((err) => {
            if (
              err.name !== "NavigationDuplicated" &&
              !err.message.includes(
                "Avoided redundant navigation to current location"
              )
            ) {
              // But print any other errors to the console
              console.error(err);
            }
          });
        // this.regulator_message = "Input the Splicing Regulator or Gene Name."
      } else if (val && this.regulator_list.includes(val)) {
        this.regulator_select = val;
        // this.regulator_message = null;
        this.isDisableReset = false;
        this.highlightNodes = [];

        // Firstly, darken before's regulator's lines
        this.darkenNerbor();

        this.showSelectedRegulators(val);
      } else {
        this.highlightNodes = [];
        this.regulator_select = null;
      }
    },
    regulator_search(newValue, oldValue) {
      if (newValue !== oldValue) {
        newValue &&
          newValue !== this.regulator_select &&
          this.regulatorQuerySelections(newValue);
      }
    },
  },
  computed: {
    nodes() {
      // 去重
      let nodes = this.nodeList.slice();
      let nodeIds = [];
      nodes = nodes.filter((node) => {
        if (nodeIds.indexOf(node.id) === -1) {
          nodeIds.push(node.id);
          return true;
        } else {
          return false;
        }
      });
      return nodes;
    },
    links() {
      return this.linkList;
    },
    theme() {
      // light
      if (this.svgTheme === "light") {
        return {
          bgcolor: "white",
          nodeStroke: "#616161",
          linkStroke: "lightgray",
          textFill: "black",
        };
      } else {
        // dark
        return {
          bgcolor: "black",
          nodeStroke: "white",
          linkStroke: "rgba(200,200,200)",
          textFill: "white",
        };
      }
    },
    filteredLinks() {
      let regulator = this.$route.query.regulator;
      if (regulator) {
        return this.links.filter(
          (v) => v.source.id == regulator || v.target.id == regulator
        );
      } else {
        return this.links;
      }
    },
  },
  methods: {
    initData() {
      this.force = d3
        .forceSimulation(this.nodes)
        .force(
          "link",
          d3
            .forceLink(this.links)
            .id((d) => d.id)
            .distance(this.linkDistance)
        )
        .force("charge", d3.forceManyBody().strength(this.bodyStrength)) // The strength of the attraction or repulsion
        .force(
          "center",
          d3.forceCenter(this.svgSize.width / 2, this.svgSize.height / 2)
        )
        .force("radial", d3.forceRadial(40, 0, 0))
        .force("collide", d3.forceCollide().radius(20).iterations(3));

      // console.log(this.nodes);
      // console.log(this.links);
    },
    initDragTickZoom() {
      // 给节点添加拖拽
      d3.selectAll(".node").call(this.drag(this.force));
      this.force.on("tick", () => {
        // 更新连线坐标
        d3.selectAll(".link")
          .data(this.links)
          .attr("x1", (d) => d.source.x)
          .attr("y1", (d) => d.source.y)
          .attr("x2", (d) => d.target.x)
          .attr("y2", (d) => d.target.y);
        d3.selectAll(".link-text")
          .data(this.links)
          .attr("x", (d) => (d.source.x + d.target.x) / 2)
          .attr("y", (d) => (d.source.y + d.target.y) / 2);
        // 更新节点坐标
        d3.selectAll(".node")
          .data(this.nodes)
          .attr("cx", (d) => d.x)
          .attr("cy", (d) => d.y);
        // 更新文字坐标
        d3.selectAll(".node-text")
          .data(this.nodes)
          .attr("x", (d) => d.x)
          .attr("y", (d) => d.y);
      });

      // 初始化 zoom
      this.zoom
        .extent([
          [0, 0],
          [this.svgSize.width, this.svgSize.height],
        ])
        .scaleExtent([0.18, 4])
        .on("zoom", this.zoomed);
      // here must be 'div#network > svg', or zoom failed. Because exists the svg icons
      let svg = d3.select("div#network > svg");
      svg.call(this.zoom).on("dblclick.zoom", null);

      // init the network (scale(0.2))
      this.reSet();
    },
    clickNode(e) {
      this.regulator_select = e.target.__data__.id;
      // if (this.pinned.length === 0) {
      //   this.pinnedState(e);
      // } else {
      //   d3.selectAll(".element").style("opacity", 0.05);
      //   this.pinned = [];
      // }
      // this.$emit("clickNode", e, e.target.__data__);
    },
    clickNodeText(e) {
      // console.log(e.target.__data__);
      this.regulator_select = e.target.__data__.id;
    },
    clickLink(e) {
      this.goToDetails(
        e.target.__data__.event_id,
        e.target.__data__.cancer_name,
        e.target.__data__.pubmed_id
      );
      // this.$emit("clickLink", e, e.target.__data__);
    },
    clickEle(e) {
      if (e.target.tagName === "circle") {
        this.clickNode(e);
      } else if (e.target.tagName === "line") {
        this.clickLink(e);
      } else if (e.target.tagName === "text") {
        this.clickNodeText(e);
      } else {
        // click blank region to init
        if (this.regulator_select) {
          this.hideSelectedRegulators(this.regulator_select);
          this.regulator_select = null;
        }
      }
    },
    svgMouseover(e) {
      // console.log(e.target.__data__);
      // forbidden when regulator exists
      if (!this.$route.query.regulator) {
        if (e.target.nodeName === "circle" || e.target.nodeName === "text") {
          // first hide all
          this.hideAllNodeTextAndOpacity();

          if (this.pinned.length === 0) {
            this.selectedState(e);
          }
          // 强制刷新
          this.$forceUpdate();
          this.$emit("hoverNode", e, e.target.__data__);
        } else if (e.target.nodeName === "line") {
          // 显示关系文本
          this.linkTextPosition = {
            left: e.clientX + "px",
            top: e.clientY - 50 + "px",
          };
          this.linkTextContent = e.target.__data__[this.linkTextKey];
          this.linkTextVisible = true;
          this.$emit("hoverLink", e, e.target.__data__);
        }
      }
    },
    svgMouseout(e) {
      // forbidden when regulator exists
      if (!this.$route.query.regulator) {
        // first show key regualtor
        this.showKeyNodeTextAndOpacity();

        this.linkTextVisible = false;
        if (e.target.nodeName === "circle") {
          if (this.pinned.length === 0) {
            this.noSelectedState(e);
          }
          // 强制刷新
          this.$forceUpdate();
        }
      }
    },
    selectedState(e) {
      // 节点自身显示文字、增加 selected class、添加进 selection
      e.target.__data__.showText = true;
      e.target.classList.add("selected");
      this.selection.nodes.push(e.target.__data__);
      // 周围节点显示文字、边和结点增加 selected class、添加进 selection
      this.lightNeibor(e.target.__data__);
      // 除了 selected 的其余节点透明度减小
      d3.selectAll(".element").style("opacity", 0.05);
    },
    noSelectedState(e) {
      // 节点自身不显示文字、移除 selected class
      e.target.__data__.showText = false;
      // e.target.classList.remove("selected");
      // 周围节点不显示文字、边和结点移除 selected class
      this.darkenNerbor();
      // 所有节点透明度恢复
      d3.selectAll(".element").style("opacity", 1);
    },
    pinnedState(e) {
      this.pinned.push(e.target.__data__.index);
      d3.selectAll(".element").style("opacity", 0.05);
    },
    lightNeibor(node) {
      this.links.forEach((link) => {
        if (link.source.index === node.index) {
          link.selected = "selected";
          this.selection.links.push(link);
          this.selection.nodes.push(link.target);
          this.lightNode(link.target);
        }
        if (link.target.index === node.index) {
          link.selected = "selected";
          this.selection.links.push(link);
          this.selection.nodes.push(link.source);
          this.lightNode(link.source);
        }
      });
    },
    lightNode(selectedNode) {
      this.nodes.forEach((node) => {
        if (node.index === selectedNode.index) {
          node.showText = true;
        }
      });
    },
    darkenNerbor() {
      this.links.forEach((link) => {
        this.selection.links.forEach((selectedLink) => {
          if (selectedLink.id === link.id) {
            link.selected = "";
          }
        });
      });
      this.nodes.forEach((node) => {
        this.selection.nodes.forEach((selectednode) => {
          if (selectednode.id === node.id) {
            node.showText = false;
          }
        });
      });
      // 清空 selection
      this.selection.nodes = [];
      this.selection.links = [];
    },
    zoomed(event) {
      let g = d3.select("#container");
      g.attr("transform", event.transform);
      // d3.select("#container").attr(
      //   "transform",
      //   "translate(" +
      //   event.transform.x +
      //   "," +
      //   event.transform.y +
      //   ") scale(" +
      //   event.transform.k +
      //   ")"
      // );
    },
    drag(simulation) {
      function dragstart(event, d) {
        if (!event.active) {
          simulation.alphaTarget(0.3).restart();
        }
        d.fx = d.x;
        d.fy = d.y;
      }

      function dragged(event, d) {
        d.fx = event.x;
        d.fy = event.y;
      }

      function dragend(event, d) {
        if (!event.active) {
          simulation.alphaTarget(0);
        }
        d.fx = null;
        d.fy = null;
      }

      return d3
        .drag()
        .on("start", dragstart)
        .on("drag", dragged)
        .on("end", dragend);
    },
    getNodeTextX(node_size) {
      if (node_size == 50) {
        return "-52";
      } else if (node_size == 30) {
        return "-24";
      } else if (node_size == 24) {
        return "-18";
      } else if (node_size == 22) {
        return "-18";
      } else {
        return "-12";
      }
    },
    getNodeTextY(node_size) {
      if (node_size == 50) {
        return "15";
      } else if (node_size == 30) {
        return "7";
      } else if (node_size == 24) {
        return "5";
      } else if (node_size == 22) {
        return "4";
      } else {
        return "3";
      }
    },
    getNodeTextSize(node_size) {
      if (node_size == 50) {
        return "33";
      } else if (node_size == 30) {
        return "15";
      } else if (node_size == 24) {
        return "15";
      } else if (node_size == 22) {
        return "14";
      } else {
        return "9";
      }
    },
    async getAllRegulatoryNetwork() {
      await getAllRegulatoryNetwork()
        .then((data) => {
          if (data) {
            // console.log(data);
            // this.regulator_node_size = data[0].regulator;

            let node_ids = [];
            data[0].nodes.forEach((v) => {
              node_ids.push(v.id);

              if (v.node_size >= 22) {
                v.showText = true;
              } else {
                v.showText = false;
              }
            });
            this.regulator_list = node_ids; // all nodes genes

            this.nodeList = data[0].nodes;
            // console.log(this.nodes);

            this.linkList = data[0].links;
          }
        })
        .catch((err) => console.error(err));
    },
    regulatorQuerySelections(v) {
      // this.regulator_message = null;
      this.regulator_loading = true;
      this.regulator_error_message = null;
      setTimeout(() => {
        this.regulator_items = this.regulator_list.filter((e) => {
          let pattern = new RegExp(v, "ig");
          return pattern.test(e);
        });
        this.regulator_loading = false;
        // show the no data tips when the search result is null
        if (this.regulator_items.length == 0) {
          this.regulator_error_message =
            "Sorry, we cant' find this Gene you input.";
        }
      }, 500);
    },
    showSelectedRegulators(regulator) {
      // console.log(regulator);

      // first hide all
      this.hideAllNodeTextAndOpacity();

      this.highlightNodes.push(regulator);
      // console.log(d3.selectAll(".node-text"));
      let node_text = d3.selectAll(".node-text").filter(function () {
        // console.log(d3.select(this).text().trim());
        // console.log(d3.select(this).text().trim() == regulator);
        // 这里的 trim() 是为了去掉空格，花费了我很多时间！！！
        return d3.select(this).text().trim() === regulator;
      });
      // console.log(node_text);
      let element = node_text.select(function () {
        return this.previousElementSibling;
      });
      let node = element._groups[0][0];
      // console.log(element);
      // console.log(node);

      // node_text.style("display", "block");
      // node.classList.add("selected");
      // console.log(node.classList);
      node.__data__.showText = true;
      this.selection.nodes.push(node.__data__);
      this.lightNeibor(node.__data__);
      this.$forceUpdate();

      setTimeout(() => {
        this.moveToNode(node);
      }, 1000);

      this.$router
        .push({
          path: "/tools/regnet",
          query: {
            regulator: regulator,
          },
        })
        .catch((err) => {
          if (
            err.name !== "NavigationDuplicated" &&
            !err.message.includes(
              "Avoided redundant navigation to current location"
            )
          ) {
            // But print any other errors to the console
            console.error(err);
          }
        });
    },
    hideSelectedRegulators(regulator) {
      // first show key regualtor
      this.showKeyNodeTextAndOpacity();
      this.reSet();

      // console.log(regulator);
      this.highlightNodes.pop(regulator);
      this.linkTextVisible = false;

      let node_text = d3.selectAll(".node-text").filter(function () {
        return d3.select(this).text() == regulator;
      });
      let element = node_text.select(function () {
        return this.previousElementSibling;
      });
      let node = element._groups[0][0];

      // hide the regulator node-text and nerbor node-text
      node.__data__.showText = false;
      this.darkenNerbor(node.__data__);
      this.$forceUpdate();
    },
    moveToNode(node) {
      let [x, y] = [node.__data__.x, node.__data__.y];
      // console.log(x, y);
      let zoom = this.zoom;
      // console.log(zoom);
      let svg = d3.select("div#network > svg");
      // console.log(svg);
      let width = svg.attr("width");
      let height = svg.attr("height");

      // svg.transition().duration(2000).call(
      //   zoom.transform,
      //   d3.zoomIdentity.translate(width / 2, height / 2)
      //     .scale(0.6).translate(-x, -y)
      // );
      svg
        .transition()
        .duration(2000)
        .call(
          zoom.transform,
          d3.zoomIdentity
            .translate(0, height / 2)
            .scale(0.6)
            .translate(-x, -y)
        );
    },
    hideAllNodeTextAndOpacity() {
      // hide all node-text
      this.nodes.forEach((node) => {
        node.showText = false;
      });
      d3.selectAll(".element").style("opacity", 0.05);
    },
    showKeyNodeTextAndOpacity() {
      // show key regulators node-text
      this.nodes.forEach((node) => {
        if (node.node_size >= 22) {
          node.showText = true;
        } else {
          node.showText = false;
        }
      });
      d3.selectAll(".element").style("opacity", 1);
    },
    reSet() {
      let svg = d3.select("div#network > svg");
      //1s内完成缩放
      svg.call(
        this.zoom.transform,
        d3.zoomIdentity.translate(0, 300).scale(0.18),
        d3.zoomTransform(svg.node())
      );
    },
    plotNetworkLegend() {
      const svg = d3.select("div#network-legend > svg");
      let as_types = [
        "Splicing Regulator",
        "ES",
        "IR",
        "MEX",
        "A3SS",
        "A5SS",
        "Complex",
      ];
      // const myColor = d3.scaleOrdinal(as_types,
      //   ['#d62728', '#1f77b4', '#ff7f0e', '#2ca02c', '#9467bd', '#bcbd22', '#17becf']);
      const myColor = d3.scaleOrdinal(as_types, [
        "#f15854",
        "#5da5da",
        "#decf3f",
        "#b276b2",
        "#faa43a",
        "#60bd68",
        "#8d4b08",
      ]);
      // const myColor = d3.scaleOrdinal(as_types, d3.schemeCategory10);
      // const myColor = d3.scaleOrdinal(as_types,
      //   [d3.schemeCategory10[0], d3.schemeCategory10[1], d3.schemeCategory10[2],
      //   d3.schemeCategory10[3], d3.schemeCategory10[4],
      //   d3.schemeCategory10[5], d3.schemeCategory10[6]]);

      // add legend-circle
      svg
        .append("g")
        .attr("class", "legend-circle")
        .selectAll()
        .data(as_types)
        .join("circle")
        .attr("cx", "20%")
        .attr("cy", function (d, i) {
          return `${12 + i * 8}%`;
        })
        .attr("r", 18)
        .attr("stroke", "white")
        .attr("stroke-width", "4")
        .style("fill", (d) => myColor(d));
      // add legend-text
      svg
        .append("g")
        .attr("class", "legend-text")
        .selectAll()
        .data(as_types)
        .join("text")
        .attr("x", "35%")
        .attr("y", function (d, i) {
          return `${12.7 + i * 8}%`;
        })
        .style("font-size", "15px")
        .style("font-family", "Arial")
        .style("font-weight", "bold")
        .text((d) => d);
    },
    goToVisualiztion(genename, astype, coordinate) {
      this.$router
        .push({
          path: "/splicevis",
          query: {
            genename: genename,
            astype: astype,
            coordinate: coordinate,
          },
          // NavigationDuplicated: Avoided redundant navigation to current location
          // (https://stackoverflow.com/questions/62462276/how-to-solve-avoided-redundant-navigation-to-current-location-error-in-vue)
        })
        .catch((err) => {
          if (
            err.name !== "NavigationDuplicated" &&
            !err.message.includes(
              "Avoided redundant navigation to current location"
            )
          ) {
            // But print any other errors to the console
            logError(err);
          }
        });
    },
    goToDetails(eventid, cancername, pubmedid) {
      this.$router
        .push({
          path: "/browse/knowledge/details",
          query: {
            eventid: eventid,
            cancername: cancername,
            pubmedid: pubmedid,
          },
          // NavigationDuplicated: Avoided redundant navigation to current location
          // (https://stackoverflow.com/questions/62462276/how-to-solve-avoided-redundant-navigation-to-current-location-error-in-vue)
        })
        .catch((err) => {
          if (
            err.name !== "NavigationDuplicated" &&
            !err.message.includes(
              "Avoided redundant navigation to current location"
            )
          ) {
            // But print any other errors to the console
            logError(err);
          }
        });
    },
    goToRegulationExplorer(genename, source, project, eventid) {
      if (genename && source && project != "-") {
        this.$router
          .push({
            path: "/tools/regexp",
            query: {
              genename: genename,
              source: source,
              project: project,
              eventid: eventid,
            },
          })
          .catch((err) => {
            if (
              err.name !== "NavigationDuplicated" &&
              !err.message.includes(
                "Avoided redundant navigation to current location"
              )
            ) {
              // But print any other errors to the console
              logError(err);
            }
          });
      }
    },
    goToSurvival(genename, source, project, eventid) {
      if (genename && source && project != "-") {
        this.$router
          .push({
            path: "/tools/survival/asevent",
            query: {
              genename: genename,
              source: source,
              project: project,
              eventid: eventid,
            },
          })
          .catch((err) => {
            if (
              err.name !== "NavigationDuplicated" &&
              !err.message.includes(
                "Avoided redundant navigation to current location"
              )
            ) {
              // But print any other errors to the console
              logError(err);
            }
          });
      }
    },
    goToStaging(genename, source, project, eventid) {
      if (genename && source && project != "-") {
        this.$router
          .push({
            path: "/tools/stage/asevent",
            query: {
              genename: genename,
              source: source,
              project: project,
              eventid: eventid,
            },
          })
          .catch((err) => {
            if (
              err.name !== "NavigationDuplicated" &&
              !err.message.includes(
                "Avoided redundant navigation to current location"
              )
            ) {
              // But print any other errors to the console
              logError(err);
            }
          });
      }
    },
    svgToPdfExample(svg, name) {
      const doc = new window.PDFDocument();
      const chunks = [];
      const stream = doc.pipe({
        // writable stream implementation
        write: (chunk) => chunks.push(chunk),
        end: () => {
          const pdfBlob = new Blob(chunks, {
            type: "application/octet-stream",
          });
          var blobUrl = URL.createObjectURL(pdfBlob);
          //window.open(`${blobUrl}?customfilename.pdf`);

          /* custom file name download */
          const a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = blobUrl;
          a.download = name; // <---- 👈 file name
          a.click();
          window.URL.revokeObjectURL(blobUrl);
        },
        // readable streaaam stub iplementation
        on: (event, action) => { },
        once: (...args) => { },
        emit: (...args) => { },
      });

      window.SVGtoPDF(doc, svg, -250, 100, { useCSS: true });
      doc.end();
    },
    downloadNetwork() {
      // console.log('download');
      let svg = d3.select("div#network > svg")._groups[0][0];
      // console.log(svg);
      let name = "Splicing_Regulatory_Network.pdf";
      this.svgToPdfExample(svg, name);
    },
  },
};
</script>
<style scoped lang="sass">
.element
  transition: opacity 0.5s ease

.selected
  opacity: 1 !important

.node,
.link,
.node-text
  cursor: pointer

.linkText
  position: absolute
  z-index: 10
  background-color: rgba(75, 75, 75, 0.596)
  border-radius: 10px
  color: white
  padding: 10px

a
  text-decoration: none
  color: #2196F3

a:hover
  text-decoration: underline

.v-data-table ::v-deep th
  font-size: 0.87rem !important
.v-data-table ::v-deep td
  font-size: 0.875rem !important

.v-btn
  text-transform: none
  letter-spacing: 0em
  font-size: 0.875rem

.v-sheet.v-card
  border-radius: 15px

.breadcrumb
  line-height: 1
  display: inline-block
  margin: 0 0
  vertical-align: middle
  padding: 8px 15px
  margin-top: -5px
  margin-bottom: 25px
  list-style: none
  background-color: #f5f5f5
  border-radius: 4px

.data-table-style
  border: thin solid rgba(0, 0, 0, 0.12)

.show-hide-btn
  right: -94%

.download-btn
  right: -95%

.search_input
  // max-width: 40%
  right: 1%

// set the width of guide
::v-deep .v-step
  max-width: 600px
  text-align: start

// set the style of highlight
.v-tour__target--highlighted
  border: 1px red solid
  border-radius: 0.8rem
  box-shadow: 0 0 0 99999px rgba(0,0,0,.4)

.guide-btn-style
  position: fixed
  right: 1%
  top: 90%
  transform: translateY(-50%)
  z-index: 99
</style>